import React from "react";
import { Helmet } from "react-helmet-async";

const SITE = "https://facow360.com";

const ROUTE_LABELS = {
  fr: {
    "/": "Accueil",
    "/geobiologie": "Géobiologie de l'habitat",
    "/cuisine-vivante": "Cuisine Vivante",
    "/magnetisme": "Magnétisme",
    "/therapeutes": "Thérapeutes recommandés",
    "/boutique": "Boutique d'affiliation",
    "/contact": "Contact",
    "/devis": "Demande de devis",
    "/bilan": "Bilan de Vitalité",
    "/bilan-vitalite": "Bilan de Vitalité",
    "/bilan-confirmation": "Confirmation du Bilan",
    "/tarifs": "Tarifs officiels",
    "/pricing": "Tarifs officiels",
    "/mentions-legales": "Mentions légales",
    "/legal": "Mentions légales",
  },
  en: {
    "/": "Home",
    "/geobiologie": "Habitat Geobiology",
    "/cuisine-vivante": "Living Cuisine",
    "/magnetisme": "Magnetism",
    "/therapeutes": "Recommended Therapists",
    "/boutique": "Affiliate Shop",
    "/contact": "Contact",
    "/devis": "Quote request",
    "/bilan": "Vitality Assessment",
    "/bilan-vitalite": "Vitality Assessment",
    "/bilan-confirmation": "Bilan confirmation",
    "/tarifs": "Official Pricing",
    "/pricing": "Official Pricing",
    "/mentions-legales": "Legal Notice",
    "/legal": "Legal Notice",
  },
};

/**
 * BreadcrumbList JSON-LD — Schema.org structured breadcrumb for rich snippets.
 * Generated automatically from the current pathname.
 */
export const BreadcrumbJsonLd = ({ locale = "fr", pathname }) => {
  const labels = ROUTE_LABELS[locale] || ROUTE_LABELS.fr;
  const path = pathname || (typeof window !== "undefined" ? window.location.pathname : "/");

  const items = [
    {
      "@type": "ListItem",
      "position": 1,
      "name": labels["/"],
      "item": `${SITE}/`,
    },
  ];

  if (path !== "/" && labels[path]) {
    items.push({
      "@type": "ListItem",
      "position": 2,
      "name": labels[path],
      "item": `${SITE}${path}`,
    });
  }

  const data = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": items,
  };

  return (
    <Helmet>
      <script type="application/ld+json">{JSON.stringify(data)}</script>
    </Helmet>
  );
};
